var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Modals d-flex justify-content-center align-items-center",class:{modal: _vm.modal}},[(_vm.modal)?_c(_vm.modal,_vm._b({key:_vm.modal,tag:"component",on:{"close":_vm.close}},'component',_vm.toBind,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }